import React from 'react';
import Avatar from 'react-avatar';
import ProgressiveImage from 'react-progressive-image';
import Utils from '../../common/Utils';
import LightBox from 'react-image-lightbox';
import PropTypes from 'prop-types';
import './ProfileAvatar.css';
import classnames from 'classnames';

class ImageView extends  React.Component{

    static propTypes = {
        allowFullScreen: PropTypes.bool,
        src: PropTypes.string,
        thumbnail: PropTypes.string,
        round: PropTypes.bool,
        title: PropTypes.string
    };

    static defaultProps = {
        title: "Profile Image"
    };

    constructor(props){
        super(props);
        this.state = {
           isOpen: false
        };
    }

    render(){

        const props= this.props;
        return <div className="avatar">

            {this.state.isOpen && <LightBox mainSrc={props.src || props.thumbnail}
                                            reactModalStyle={{
                                                overlay:{
                                                    zIndex: 9000
                                                }
                                            }}
                                            imageTitle={this.props.title || "Profile Image"}
                                            onCloseRequest={() => this.setState({ isOpen: false })}/>}

            <img src={props.thumbnail || props.src} className={classnames(props.round ? 'img-avatar' : undefined, 'profile-avatar')} width={props.size} height={props.size} onClick={() => {

                if(props.allowFullScreen)
                    this.setState({
                        isOpen: true
                    });

            }} />

        </div>

    }

}

const ProfileAvatar = (props) => {

    let src = props.src;
    let thumb = props.thumbnail;

    if(props.media){

        const media = props.media;
        let profileSrc =  Utils.getProfileImage(media, false);
        if(profileSrc){
            src = profileSrc;
        }

        let profileThumb = Utils.getProfileImage(media, true);
        if(profileThumb){
            thumb = profileThumb;
        }

    }

    const size = props.size;
    const name = props.name;

    if (src && src.trim().length > 0) {

        if(thumb) {

            return <ProgressiveImage src={src} placeholder={thumb}>
                {(src, loading) => {
                    return <ImageView title={props.lightBoxImageTitle} round={props.round} src={src} thumbnail={thumb} size={size}  allowFullScreen={props.showFullscreen}/>
                }}
            </ProgressiveImage>
        }

        return <ImageView title={props.lightBoxImageTitle} round={props.round} allowFullScreen={props.showFullscreen} src={src} size={size}/>;
    }
    else {
        return <Avatar name={name} size={size} round={props.round}/>;
    }

};


ProfileAvatar.propTypes = {
    src: PropTypes.string,
    thumbnail: PropTypes.string,
    media: PropTypes.object,
    name: PropTypes.string,
    size: PropTypes.number,
    hint: PropTypes.string,
    showFullscreen: PropTypes.bool,
    round: PropTypes.bool,
    lightBoxImageTitle: PropTypes.string
};

ProfileAvatar.defaultProps = {
    showFullscreen: true,
    round: true
};

export default ProfileAvatar;


// WEBPACK FOOTER //
// ./src/components/ProfileAvatar/ProfileAvatar.js